const TRACK_FEATURE_LABELS: Record<string, string> = {
  lastSeenProducts: 'lastViewed',
  fittingProducts: 'fittingReco',
  similarProductsReco: 'similarItems',
};

export const getTrackFeatureLabel = (
  promotionTrackingName: string | undefined,
): string | undefined =>
  promotionTrackingName
    ? TRACK_FEATURE_LABELS[promotionTrackingName]
    : undefined;
